import React from 'react';
import { chakra, HTMLChakraProps } from '@chakra-ui/react';
import { FC, SVGProps } from 'react';

type SvgComponent = FC<SVGProps<SVGSVGElement>>;

export interface ChakraIconProps extends HTMLChakraProps<'svg'> {
	src?: SvgComponent;
}

export const SvgIcon: FC<ChakraIconProps> = ({ src: SvgComponent, ...props }) => {
	const Svg = SvgComponent ? chakra(SvgComponent) : chakra('svg');
	return <Svg {...props} />;
};